export enum MediaBreakpointDevice {
	PhoneXs = 'phone-xs',
	Phone = 'phone',
	PhoneLg = 'phone-lg',
	Tablet = 'tablet',
	Laptop = 'laptop',
	Widescreen = 'widescreen',
}
